module.exports = __webpack_public_path__ + "static/media/discord.86f782b1.png";